/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Jade_Hawk_ScanInputs */

const en_deep_jade_hawk_scan = /** @type {(inputs: Deep_Jade_Hawk_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom config`)
};

const de_deep_jade_hawk_scan = /** @type {(inputs: Deep_Jade_Hawk_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigene Konfiguration`)
};

/**
* | output |
* | --- |
* | "Custom config" |
*
* @param {Deep_Jade_Hawk_ScanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const deep_jade_hawk_scan = /** @type {((inputs?: Deep_Jade_Hawk_ScanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Jade_Hawk_ScanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deep_jade_hawk_scan(inputs)
	return de_deep_jade_hawk_scan(inputs)
});